/**
 * Converts a numeric value into a string representing a monetary amount with two decimal places,
 * using a comma as the decimal separator and inserting periods as thousand separators.
 */
export const formatMoneyValue = (value: number): string =>
  `€ ${value
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
